(function ($) {
  'use strict';

  var initTestimonialCarousel = function () {

    //toggle dots vs. arrows
    var toggleDots = function (slider) {
      var showArrowsMinWidth = slider.parent().hasClass('js-testimonial-slick') ? 740 : 1260;
      //show/hide dots vs. thumbnails
      if (slider.width() < showArrowsMinWidth) {
        slider.find('.slick-arrow').hide();
        slider.find('.slick-dots').show();
      } else {
        slider.find('.slick-arrow').show();
        slider.find('.slick-dots').hide();
      }
    };

    //get all testimonials
    var testimonials = $('.testimonial__items');

    //init each testimonial
    testimonials.each(function () {
      //init only if it has more than one slide
      var slidesNum = $(this).find('.testimonial__item').length;

      if (slidesNum > 1) {
        var slider = $(this).slick({
          dots: true,
          infinite: false,
          dotsClass: 'slick-dots slick-dots--colored',
          prevArrow: '<button class="btn btn--chevron btn--chevron-left slick-prev"><svg focusable="fa' +
            'lse" xmlns="http://www.w3.org/2000/svg" width="10" height="16"><path fill="#7D51' +
            '77" fill-rule="evenodd" d="M1.893 0L0 1.868 6.214 8 0 14.13 1.893 16 10 8z" /></' +
            'svg>Next</button>',
          nextArrow: '<button class="btn btn--chevron btn--chevron slick-next"><svg focusable="false" ' +
            'xmlns="http://www.w3.org/2000/svg" width="10" height="16"><path fill="#7D5177" f' +
            'ill-rule="evenodd" d="M1.893 0L0 1.868 6.214 8 0 14.13 1.893 16 10 8z" /></svg>P' +
            'revious</button>'
        });

        toggleDots(slider);
      }
    });

    var resizeTimer;
    var sliders = $('.testimonial .slick-slider');

    //show hide carousel arrows/dots
    $(window).on('resize', function () {
      // throttle resize event
      // https://css-tricks.com/snippets/jquery/done-resizing-event/
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        sliders.each(function () {
          toggleDots($(this));
        });
      }, 100);
    });
  };

  //init banner carousel
  initTestimonialCarousel();
}(jQuery));